import React from "react"
import { Link } from "@tanstack/react-router"
import { IconCircleArrowUpOutline18 as ArrowUpCircleIcon } from "nucleo-ui-outline-18"

import type { Plan } from "@productlane/lib/src/browser"
import type { ButtonProps } from "@productlane/ui"
import { Button, Tooltip } from "@productlane/ui"

import { useRequiredPlans } from "@/lib/plans"

interface UpgradeButtonProps extends ButtonProps {
	required: Plan[]
	withTooltip?: boolean
}

export const UpgradeButton = React.memo(
	({ required, withTooltip, className, ...props }: UpgradeButtonProps) => {
		const { passes } = useRequiredPlans(required)

		if (passes) {
			return null
		}

		const inner = (
			<Link to={`/settings/plans`}>
				<Button
					Icon={ArrowUpCircleIcon}
					variant="outline"
					className={className}
					{...props}
				>
					Upgrade to <span className="mx-0.5 capitalize">{required[0]}</span>
				</Button>
			</Link>
		)

		if (!withTooltip) {
			return inner
		}

		return (
			<Tooltip label={`Upgrade to the ${required[0]} plan for access`}>
				{inner}
			</Tooltip>
		)
	},
)
